import { render, staticRenderFns } from "./pessoa-fisica-detalhe-dados.vue?vue&type=template&id=30ca1b79&"
import script from "./pessoa-fisica-detalhe-dados.vue?vue&type=script&lang=js&"
export * from "./pessoa-fisica-detalhe-dados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports